<template>
    <div>
        <!-- pc端右侧就医指南 -->
        <div class="navRight">
            <div class="navRight_seekGUI">
                <div class="navRight_title">
                    <p>就医指南</p>
                    <img src="../static/imgs/组 5.png">
                </div>
               
                <ul>
                    <li @click="goCenter()">
                        <img src="../static/imgs/jiuhucheambulance9.png">
                        <p>出诊安排</p>
                    </li>
                    <li @click="goCenter()">
                        <img src="../static/imgs/jiuhucheambulance9.png">
                        <p>预约挂号</p>
                    </li>
                    <li @click="goCenter()">
                        <img src="../static/imgs/jiuhucheambulance9.png">
                        <p>智慧就医</p>
                    </li>
                    <li @click="goCenter()">
                        <img src="../static/imgs/jiuhucheambulance9.png">
                        <p>院长信箱</p>
                    </li>
                    <li @click="goCenter()">
                        <img src="../static/imgs/jiuhucheambulance9.png">
                        <p>信息公开</p>
                    </li>
                    <li @click="goCenter()">
                        <img src="../static/imgs/jiuhucheambulance9.png">
                        <p>投诉电话</p>
                    </li>
                </ul>
            </div>
            
            <div class="navRight_serve">
                 <div class="navRight_title">
                    <p>医疗服务</p>
                    <img src="../static/imgs/组 5.png">
                </div>
                <ul>
                    <li @click="$router.push('/outpatient?id=17&name=门诊服务')">
                        <img src="../static/imgs/1ef464ee498d16f86477014be80f45fc.png" alt="">
                        <p>就医指南</p>
                        <span>MEDICAL GUIDELINES</span>
                    </li>
                    <li @click="$router.push('/outpatient?id=17&name=门诊服务')">
                        <img src="../static/imgs/f356801f81c93a3f3d6f03f82aaa717c.png" alt="">
                        <p>门诊服务</p>
                        <span>MEDICAL GUIDELINES</span>
                    </li>
                    <li @click="$router.push('/manpower?id=20&name=人才建设')">
                        <img src="../static/imgs/f3a53472d2517f56a97cb28164d11aaf.png" alt="">
                        <p>人事招聘</p>
                        <span>MEDICAL GUIDELINES</span>
                    </li>
                    <li @click="$router.push('/managequality?id=25&name=基层党建')">
                        <img src="../static/imgs/b48e8052d7236a909853c830ac853e59.png" alt="">
                        <p>基层党建</p>
                        <span>MEDICAL GUIDELINES</span>
                    </li>
                </ul>
            </div>

            <img class="dangjian" src="../static/imgs/组 7.png"/>

            
        </div>
    </div>
</template>

<script>
export default {
    name: 'HospitalGUI',

    data() {
        return {
            
        };
    },

    mounted() {
        
    },

    methods: {
        goCenter(){
            this.$router.push('/center')
        },
        gooutpatient(){
            this.$router.push('/outpatient')
        },
        gobuild(){
            this.$router.push('/building')
        }
    },
};
</script>

<style  scoped>
@import url('../static/css/style.css');

</style>